
export default (show) => {
    const overlay = $('#isOverlay');
    const body = $('body');
    if (typeof show === 'undefined' || show) {
        overlay.removeClass('d-none');
        overlay.addClass('d-block');
        overlay.addClass('active');
    } else if (overlay.hasClass('active')) {
        overlay.removeClass('d-block');
        overlay.addClass('d-none');
    }
}

export function backdrop(show) {
    $('body').toggleClass('is-backdrop', show);
}
